<template>

<div>
  <div class="head">
  	<div class="head_img">
  		<img src="../assets/boloni.jpg" />
  	</div>
  </div>
  	<div class="main" :model="from">
    		<div class="main_check">
    			<h2>博洛尼供应商报名</h2>
    					<div class="main_login_input">
    						<span class="input-group-addon"><i class="fa fa-user-o fa-fw"></i></span>
    						<input class="form-control" type="text" placeholder="请使用供应商名称作为账号"  v-model="from.userName">
    					</div>
    					<div class="main_login_input">
    						<span class="input-group-addon"><i class="fa fa-key fa-fw"></i></span>
    						<input class="form-control" type="password"  placeholder="请输入登录密码"  v-model="from.passWord">
    					</div>
    					<div class="main_login_button">
    						<button type="button" @click="addUser()" ><span>注册</span></button>
    						<button type="button" style="background-color: #27eaff" @click="loginUser()"><span>登录</span></button>
    					</div>
    		</div>
    	</div>
</div>
</template>

<script>
import { loginUser, addUser, loginMan } from '../api/LoginApi.js'
import md5 from 'js-md5'
import { messageError, messageSuCcEss } from '../utils/message'
export default {
  name: 'LeaveAdd',
  data () {
    return {
      imgSrc: require('../assets/images/行业具备资料.png'),
      from: {
        userName: '',
        passWord: ''
      }
    }
  },
  methods: {
    loginUser: function () {
      let userName = this.from.userName
      let passWord = this.from.passWord
      if (!userName) {
        messageError('请输入账号!')
        return false
      }
      if (!passWord) {
        messageError('请输入密码!')
        return false
      }
      // ...this.from 将this.from里面所有的字段解出来
      loginUser(userName, passWord).then(res => {
        if (res.code === 200) {
          messageSuCcEss(res.msg)
          // 登录成功后调用系统生成会话id
          loginMan('robotuser', md5('robotuser')).then(res => {
            if (res.loginguid) {
              window.loginguid = res.loginguid
              localStorage.setItem('loginguid', res.loginguid)
              const vm = this
              vm.$router.push({ path: '/GysBasic' })
              localStorage.setItem('userName', this.from.userName)
            }
          })
        } else {
          messageError(res.msg)
        }
      })
    },
    addUser: function () {
      let userName = this.from.userName
      let passWord = this.from.passWord
      if (!userName) {
        messageError('请输入账号!')
        return false
      }
      if (!passWord) {
        messageError('请输入密码!')
        return false
      }
      // ...this.from 将this.from里面所有的字段解出来
      addUser({ ...this.from }).then(res => {
        try {
          if (res.code === 200) {
            messageSuCcEss(res.msg)
          }
          // else {
          //   messageError(res.msg)
          //   return this.$message.error('账号已存在')
          // }
        } catch (e) {
          messageError('账号已存在')
        }
      })
    }
  }
}
</script>

<style scoped>

 
 @import "../css/Main.css";
</style>



// WEBPACK FOOTER //
// src/components/Login.vue